var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu_box",style:({
    height: _vm.content.textStyle.height + 'rem' || '',
    fontFamily: _vm.content.textStyle.fontFamily || '',
    fontSize: _vm.content.textStyle.fontSize + 'rem' || '',
    lineHeight: _vm.content.textStyle.lineHeight + 'rem' || '',
    maxWidth: _vm.content.textStyle.maxWidth + 'rem' || '',
    textIndent:
      _vm.content.textStyle.textIndent &&
      typeof _vm.content.textStyle.textIndent === 'string'
        ? _vm.content.textStyle.textIndent
        : _vm.content.textStyle.textIndent &&
          typeof _vm.content.textStyle.textIndent === 'number'
        ? _vm.content.textStyle.textIndent + 'rem'
        : '',
    fontWeight: _vm.content.textStyle.fontWeight || '',
    textDecoration: _vm.content.textStyle.underline === 1 ? 'underline' : '',
    fontStyle: _vm.content.textStyle.fontItalic === 1 ? 'italic' : '',
    textAlign: _vm.content.textStyle.textAlign || '',
    color: _vm.content.textStyle.color || '',
    backgroundColor: _vm.content.textStyle.backgroundColor || '',
    backgroundImage: _vm.content.textStyle.backgroundImage
      ? ("url(" + (_vm.content.textStyle.backgroundImage) + ")")
      : '',
    padding: '0 20rem',
  }),on:{"click":function($event){return _vm.expandRowClick(_vm.content)}}},[_c('span',{staticClass:"menu_title"},[_vm._v(_vm._s(_vm.content.text))]),_c('img',{staticClass:"menu_arrow",attrs:{"src":!_vm.content.isexpand
        ? require('@/assets/images/books/book2/retract.png')
        : require('@/assets/images/books/book2/expend.png'),"alt":""}}),_c('pdfPreview',{ref:"pdfPreview",attrs:{"dialogVisible":_vm.dialogVisible,"dialogContent":_vm.dialogContent},on:{"dialogClose":_vm.dialogClose}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }